export const advertisementSchema = {
  fields: [
    {
      name: 'mediaFile',
      label: 'Video or Image File',
      type: 'file',
      required: true,
    },
    {
      name: 'pageType',
      label: 'Page Type',
      type: 'select',
      placeholder: 'Select page type',
      required: true,
      options: [
        { label: 'Landscape', value: 'landscape' },
        { label: 'Portrait',  value: 'portrait' },
      ],
    },
    {
      name: 'status',
      label: 'Status',
      type: 'radio',
      required: true,
      options: [
        { label: 'Active',   value: 'Active' },
        { label: 'Inactive', value: 'Inactive' },
      ],
      defaultValue: 'Active',
    },
  ],
  buttons: [
    { label: 'Cancel', action: 'cancel', type: 'button', className: 'btn-back' },
    { label: 'Save',   action: 'save',   type: 'button', className: 'btn-next' },
  ],
};